export const WAITING_TIME_AFTER_PICKUP = 3
